<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-model='thePostId'
            clearable 
            @change="thePostChange" 
            size='small'
            placeholder="请选择岗位">
  			    <el-option
              v-for="item in getPostList_data.data||[]"
              :key="item.postId"
              :label="item.postName"
              :value="item.postId">
            </el-option>
  		  </el-select>
        <el-input
          v-model="getUserList_data.userName"
          placeholder="请输入用户名"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-input
          v-model="getUserList_data.userPhone"
          placeholder="请输入手机号"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-button
          v-click.getUserList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button v-if='addUser'
          @click="$form('addUser'), getRoleList()"
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加账号
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getUserList'
      api='getUserList'
      xupdateapi='updateUser'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addUser:    [ "新增账号信息", "el-icon-circle-plus" ],
        updateUser: [ "修改账号信息", "el-icon-edit-outline"],
        $succeed$: getUserList
      }'
      @close='$form("updateUser","reset")' >
      <template v-slot:postId="{Myformdata}" >
  		  <el-select v-model='Myformdata.postId' clearable>
  			    <el-option
              v-for="item in getPostList_data.data||[]"
              :key="item.postId"
              :label="item.postName"
              :value="item.postId">
            </el-option>
  		  </el-select>
  	  </template>
      <template v-slot:roleListString="{Myformdata}" >
  		  <el-select v-model='Myformdata.roleListString' multiple clearable>
  			    <el-option
              v-for="item in getRoleList_data.data||[]"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId">
            </el-option>
  		  </el-select>
  	  </template>
      <template v-slot:loginApp="{Myformdata}" >
  		  <el-radio v-model="Myformdata.loginApp" :label='1'>是</el-radio>
        <el-radio v-model="Myformdata.loginApp" :label='2'>否</el-radio>
  	  </template>
      <template v-slot:loginPc="{Myformdata}" >
  		  <el-radio v-model="Myformdata.loginPc" :label='1'>是</el-radio>
        <el-radio v-model="Myformdata.loginPc" :label='2'>否</el-radio>
  	  </template>
       <!-- 隐藏指定字段 -->
      <hide slot='userId'/>
    </myform>

  </div>
</template>

<script>
export default {
  data() {
    return {
      userId: null,
      thePostId: "",

      tableColums_getUserList: {
        $selection: false,

        userName: '用户名',
        userAccount: '工号',
        userPhone: '手机号',
        userMail: '邮箱',
        department: [ '岗位', , '@text: {{ $row.post && $row.post.postName }}' ],
        roleNames: '角色',
        createtime: '创建时间|sortable',
        userRemark: [ "账号描述", 120 ],
        $operation: ( this.updateUser || this.deleteUser ) && [
          '操作', 200,

          this.updateUser && `@text: 编辑#success
           @click: $form("updateUser",$row), getRoleList()
          `,
          this.resetUserPassword && `@text: 重置密码#danger
           @click: _confirm('确定要重置该账号密码吗?')
                   .trigger('resetUserPassword',{userId:$row.userId})
                   .trigger('getUserList')
          `,
          this.deleteUser && `@text: 删除#danger
           @click: _confirm('确定要删除该账号吗?')
                   .trigger('deleteUser',{userListString:$row.userId+""})
                   .trigger('getUserList')
          `,

        ],

      },

    };
  },

  watch: {
    
  },

  methods: {
    thePostChange(e){
      this.thePostId=e;
      this.getData();
    },
    getData(){
      this.getUserList({postId:this.thePostId});
    }
  },

  created() {
    this.getData();
    this.getPostList({projectId:0});
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/unipue/#AccountManage.vue